export default __webpack_public_path__ + "static/media/3.26b59178.png";